import { Capacitor } from "@capacitor/core";

// Apple App Store compliance (Guideline 3.1.1): the native iOS build must not
// show prices, purchase buttons or links to external payment (Stripe).
export const isIOSNative = () => {
  try { return Capacitor.getPlatform() === "ios"; }
  catch { return false; }
};

// Google Play policy: same as Apple — no external payment links in the native
// Android app. Play Billing lands in Phase 2; until then purchases are hidden.
export const isAndroidNative = () => {
  try { return Capacitor.getPlatform() === "android"; }
  catch { return false; }
};
